var imgUtils = require('../plugins/img-utils');
require('../plugins/inview');


var mediaQuery = Foundation.MediaQuery;

/**
 *
 * Apply lazy image loading inview events
 * to images and bg images
 *
 * @param {object} $domScope - jquery element to use as root (optional)
 * @return void
 */
function initImages($domScope) {

  // Standard images and bg images
  var domScope = $domScope ? $domScope : $('body'),
    images,
    stdImages = $('img:not([data-lazyunveil]):not([data-interchange])', domScope);

  // Select all lazyloading elements, as well as
  // images and bg-images that use interchange, but not lazyload
  images = $('[data-lazyunveil], img[data-interchange], .js-lazyload-bgimg[data-interchange]');

  // Set image padding on mediaquery changed events
  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
    var currentBreakPoint = mediaQuery.current;

    images.each(function(index, el) {
      imgUtils.setImagePadding($(el), currentBreakPoint);
    });
  }).trigger('changed.zf.mediaquery');

  // // Trigger resize for orbit sliders, otherwise
  // // orbit container size is off, as updated image paddings
  // // are not considered when foundation calculates height
  // // of orbit container
  // $('.js-orbit').trigger('resizeme.zf.trigger');

  // Normal/bg images with interchange values
  images.one('inview', function (event, visible) {
    event.stopPropagation();
    $(this).lazyInterchange();
  });

  // Normal images witout interchange
  stdImages.off('inview').one('inview', function (event, visible) {
    var img = $(this);

    event.stopPropagation();

    // Preload image before showing it
    imgUtils.preload(img, function(){
      img.addClass('img-loaded');
    });
  });

  // Trigger initial scroll if images are already in view
  window.setTimeout(function(){
    $(window).trigger('scroll');
  }, 550);
}



// function setImageWidths() {
//   return;
//   $('.imgwrap.js-addimgloaded').each(function(index, el) {
//     var $this = $(this),
//       currentWidth,
//       newWidth;

//     $this[0].style.width = '';

//     currentWidth = $this.width(),
//     newWidth = Math.ceil(currentWidth + 1);

//     $this.width(newWidth);
//   });
// }





(function(){
  var reflowTimer,
    elCache = $();

  // Interchange for standard images
  // used in conjunction with inview
  $.fn.lazyInterchange = function() {

    var selectors = this.each(function() {

      var $this = $(this);

      // Only set data-interchange if not already
      // present.
      if (!$this.attr('data-interchange')) {

        elCache = elCache.add($this);

        // prevents excessive loops interchange images in foundation.interchange.js
        if (reflowTimer) {
          clearRequestTimeout(reflowTimer);
        }

        reflowTimer = requestTimeout(function(){

          elCache.each(function (index, element) {
            var $el = $(element);

            new Foundation.Interchange($el, {
              rules: $el.attr('data-lazyunveil')
            });
          });

          elCache = $();
        },200);

      }

    });
    return selectors;
  };

  $(function() {


    // Trigger unveil on window resize
    $(window).on('resize', function(event) {
      var timer;

      window.clearTimeout(timer);

      timer = window.setTimeout(function(){
        $(window).trigger('scroll');
      },100);
    });

    // Replace callback for data-src images
    $(document).on('replaced.zf.interchange', 'img[data-lazyunveil]', function (e) {
      e.stopPropagation();

      var $img = $(e.currentTarget),
        $imgParent = $img.parents('.js-addimgloaded');

      // Preload image
      imgUtils.preload($img, function(){
        $imgParent.addClass('img-loaded');
        $img.addClass('img-loaded');
      });
    });

    // Replace callback for background images
    $(document).on('replaced.zf.interchange', '.js-lazyload-bgimg', function (e) {

      var $img, $this, bgImage;

      // Don't trigger event on fx parent ajax container
      e.stopPropagation();

      $img = $(e.currentTarget);

      $this = $(this);

      bgImage = $img[0].style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

      $img = $('<img>').attr('src', bgImage);

      // Preload image before showing it
      imgUtils.preload($img, function(){
        $this.removeClass('not-unveiled').addClass('img-loaded');
      });
    });

    initImages();

    $(window).trigger('resize');

  });
})();




// WEBPACK FOOTER //
// ./src/js/modules/images.js